import { render, staticRenderFns } from "./safe-timer.vue?vue&type=template&id=0f6e0852&scoped=true&"
import script from "./safe-timer.vue?vue&type=script&lang=js&"
export * from "./safe-timer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e0852",
  null
  
)

export default component.exports